module.exports = __webpack_public_path__ + "img/_Small-Bevel-Attachment.28a2986a.jpg";